import { Component } from '@theme/component';

export class VideoBackgroundComponent extends Component {
  requiredRefs = ['videoSources', 'videoElement'];

  connectedCallback() {
    super.connectedCallback();

    const { videoSources, videoElement } = this.refs;

    // 1. Force the muted property in JS before loading
    // Chrome often ignores the HTML 'muted' attribute when sources are dynamic
    videoElement.muted = true;
    videoElement.setAttribute('muted', 'muted');
    videoElement.setAttribute('playsinline', 'true');

    for (const source of videoSources) {
      const { videoSource } = source.dataset;
      if (videoSource) {
        source.setAttribute('src', videoSource);
      }
    }

    // 2. Wrap the play call in a catch to prevent console errors
    // and ensure it actually fires after the sources are set
    videoElement.load();
    
    const playPromise = videoElement.play();
    if (playPromise !== undefined) {
      playPromise.catch(() => {
        // Autoplay was prevented; we can try to trigger it again on user interaction
        console.log("Autoplay prevented by browser policy.");
      });
    }
  }
}

if (!customElements.get('video-background-component')) {
  customElements.define('video-background-component', VideoBackgroundComponent);
}